// Import our custom CSS
 import '../scss/style.scss'
//import '../scss/menu.scss'
// import '../scss/nouislider.less'

 import "bootstrap-icons/font/bootstrap-icons.scss"
// Import all of Bootstrap's JS


//import * as bootstrap from 'bootstrap'

//mask 
import Inputmask from "inputmask";
document.querySelectorAll("form").forEach((form) => {
  const input = form.querySelector(".masked-input");
  const button = form.querySelector(".submit-button");

  if (input && button) {
    const im2 = new Inputmask("+7(999)-999-9999");
    im2.mask(input);

    input.addEventListener("input", function () {
      const digits = input.value.replace(/\D/g, ""); // Убираем все нецифровые символы
      button.disabled = digits.length !== 11; // Разблокируем только при 11 цифрах
    });
  }
});

 
 

 
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})


// Получаем все ссылки меню
const menuLinks = document.querySelectorAll('.menu-link');
// Получаем ВСЕ чекбоксы (исправленный селектор)
const menuToggles = document.querySelectorAll('.checkbox-toggle');

// Добавляем обработчик клика для каждой ссылки
menuLinks.forEach(link => {
  link.addEventListener('click', () => {
    // Снимаем отметку со всех чекбоксов
    menuToggles.forEach(toggle => {
      toggle.checked = false;
    });
  });
});

//slick
import $ from 'jquery';
import 'slick-carousel'; 
$("#slider").slick()

const button = document.getElementById("toggle-button");
const hiddenItems = document.querySelectorAll(".hidden");

button.addEventListener("click", function () {
    hiddenItems.forEach(item => {
        item.classList.toggle("hidden");
    });

    if (hiddenItems[0].classList.contains("hidden")) {
        button.textContent = "Показать больше";
    } else {
        button.textContent = "Скрыть";
    }
});
 
//window.bootstrap = bootstrap;


let lastScrollTop = 0;
const menu = document.getElementById('menu-fix');

window.addEventListener("scroll", function(){
   let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
   //console.log(scrollTop);
   if (scrollTop > lastScrollTop){ // скроллим вниз
      menu.style.top = "-140px"; // скрываем меню
   } else { // скроллим вверх
      menu.style.top = "0"; // показываем меню
   }
   if(scrollTop>200){
    menu.classList.add('bg-body-secondary'); 
   }else{
      menu.classList.remove('bg-body-secondary'); 
      menu.style.top = "-140px";
   }
   lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Для Mobile Safari
}, false);